import { Key } from '../../hotkeys/KeyStrokes.ts';
import { HotkeyBase, HotkeyModifier, LayoutHotkeyNames } from '../../hotkeys/types.ts';

export const DefaultLayoutHotKeys: Record<LayoutHotkeyNames, HotkeyBase> = {
  [LayoutHotkeyNames.NextLayoutKey]: {
    primary: Key.arrow.ArrowRight,
    hotkeyModifier: { modifier: 'Ctrl' },
    secondaryHotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.PreviousLayoutKey]: {
    primary: Key.arrow.ArrowLeft,
    hotkeyModifier: { modifier: 'Ctrl' },
    secondaryHotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.ToggleEditModeKey]: {
    primary: Key.KeyE,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.AddWidgetKey]: {
    primary: Key.KeyW,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.ReorganizeWidgetsKey]: {
    primary: Key.KeyO,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.ResetLayoutKey]: {
    primary: Key.KeyR,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.OpenLayoutIndexModalKey]: {
    primary: Key.KeyL,
    secondary: Key.KeyI,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutHotkeyNames.SaveLayoutKey]: {
    primary: Key.KeyS,
    hotkeyModifier: { modifier: 'Shift' },
  },
};

export const numKeyLayoutNavigationModifier: HotkeyModifier | undefined = { modifier: 'Shift' };
